import { render, staticRenderFns } from "./chuku.vue?vue&type=template&id=3b3bcda0&scoped=true&"
import script from "./chuku.vue?vue&type=script&lang=js&"
export * from "./chuku.vue?vue&type=script&lang=js&"
import style0 from "./chuku.vue?vue&type=style&index=0&id=3b3bcda0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bcda0",
  null
  
)

export default component.exports